<template>
  <v-container fluid align-start ma-0 pa-2 class="epms9110-main container-height">
    <v-row no-gutters class="h-full">
      <v-col cols="12">
        <i-card-vertical :headerTitle="menuTitle" class="h-full">
          <template v-slot:body>
            <v-row no-gutters>
              <v-col cols="5" class="pr-1">
                <v-row no-gutters>
                  <v-col>
                    <i-card-top
                      class="d-md-flex"
                      outlined
                      :useBtnList="useBtnList"
                      @btnRetrieve="btnRetrieve"
                    >
                      <template v-slot:body>
                        <v-row no-gutters class="center pa-2 pb-0">
                          <i-label :label="'Ship No :'" />
                          <v-col cols="3">
                            <v-select
                              v-model="selectShipNo"
                              :items="shipNoList"
                              return-object
                              item-text="shipNo"
                              item-value="shipNo"
                              single-line
                              outlined
                              dense
                              height="32"/>
                          </v-col>

                          <i-label :label="'Location :'" class="pl-2" />
                          <v-col cols="3">
                            <v-select
                              v-model="selectLocation"
                              :items="locationList"
                              return-object
                              item-text="codeName"
                              item-value="code"
                              single-line
                              outlined
                              dense
                              height="32"/>
                          </v-col>
                        </v-row>
                      </template>
                    </i-card-top>
                  </v-col>
                </v-row>

                <v-row no-gutters class="pt-1">
                  <v-col>
                    <DxDataGrid
                      class="listBox"
                      :ref="epms9110Ref"
                      :data-source="dataList" 
                      :remote-operations="false" 
                      :hover-state-enabled="true"
                      :allow-column-resizing="true" 
                      :allow-column-reordering="true"
                      :row-alternation-enabled="true" 
                      :show-borders="true" 
                      :width="grid.width"
                      :show-row-lines="true" 
                      key-expr="id" 
                      :focused-row-enabled="true"
                      :column-hiding-enabled="false" 
                      :sorting="{ mode: 'none' }"
                      :selection="{ mode: 'none' }"
                      @cellClick="cellClick"
                    >
                      <DxPaging :enabled="false" />
                      <DxPager :visible="false" />
                      <DxColumn data-field="reqIssDte" caption="Req. Date" alignment="center" :allow-editing="false" />
                      <DxColumn data-field="shipNo" caption="Ship No" alignment="center" :allow-editing="false" />
                      <DxColumn data-field="resNo" caption="Reservation No" alignment="center" :allow-editing="false" />
                    </DxDataGrid>
                  </v-col>
                </v-row>
              </v-col>

              <v-col cols="7">
                <v-row no-gutters>
                  <v-col>
                    <i-card-top
                      class="d-md-flex"
                      outlined
                      :useBtnList="useBtnList2"
                      @btnPrint="btnPrint"
                      @btnDevide="btnDevide"
                    >
                      <template v-slot:body>
                        <v-row no-gutters class="center pa-2 pb-0">
                          <i-label :label="'Reservation No :'" />
                          <v-col cols="2">
                            <v-text-field 
                              v-model="reservNo"
                              dense 
                              outlined 
                              hide-details="auto"
                              readonly
                              height="32"
                            />
                          </v-col>
                        </v-row>
                      </template>
                    </i-card-top>
                  </v-col>
                </v-row>

                <v-row no-gutters class="pt-1">
                  <v-col>
                    <DxDataGrid
                      class="listBox"
                      :ref="epms9110Ref2"
                      :data-source="dataList2" 
                      :remote-operations="false" 
                      :hover-state-enabled="true"
                      :allow-column-resizing="true" 
                      :allow-column-reordering="true"
                      :row-alternation-enabled="true" 
                      :show-borders="true" 
                      :width="grid.width"
                      :show-row-lines="true" 
                      key-expr="id" 
                      :focused-row-enabled="false"
                      :column-hiding-enabled="false" 
                      :sorting="{ mode: 'none' }"
                      @cellPrepared="cellPrepared2"
                    >
                      <DxPaging :enabled="false" />
                      <DxPager :visible="false" />
                      <DxColumn data-field="resSeq" alignment="center" :allow-editing="false" width="5%"
                                            header-cell-template="resSeqHeaderTmpl" />
                      <template #resSeqHeaderTmpl>
                        <fragment>
                          Res<br>Seq
                        </fragment>
                      </template>

                      <DxColumn caption="Ship No" alignment="center" :allow-editing="false">
                        <DxColumn data-field="shipNo" caption="POR No" alignment="center" :allow-editing="false" width="13%"
                                              cell-template="shipNoCellTmpl" />
                      </DxColumn>
                      <template #shipNoCellTmpl="{ data: cellInfo }">
                        {{ cellInfo.data.gbn === 1 ? cellInfo.data.shipNo : `${cellInfo.data.porNo}-${cellInfo.data.porSeq}` }}
                      </template>

                      <DxColumn data-field="block" caption="Block" alignment="center" :allow-editing="false" width="8%" />

                      <DxColumn caption="Part No" alignment="center" :allow-editing="false">
                        <DxColumn data-field="partNo" caption="Material Spec" alignment="center" :allow-editing="false" width="11%"
                                              cell-template="partNoCellTmpl" />
                      </DxColumn>
                      <template #partNoCellTmpl="{ data: cellInfo }">
                      {{ cellInfo.data.gbn === 1 ? cellInfo.data.partNo : cellInfo.data.matlSpec }}
                      </template>

                      <DxColumn caption="Res.Qty" alignment="center" :allow-editing="false">
                        <DxColumn data-field="resQty" caption="Material Spec1" alignment="right" :allow-editing="false" width="9%" data-type="number" format="#,##0" />
                      </DxColumn>

                      <DxColumn caption="Unit Wgt" alignment="center" :allow-editing="false">
                        <DxColumn data-field="partUnitWgt" caption="Material Spec2" alignment="right" :allow-editing="false" width="9%" data-type="number" format="#,##0.000" />
                      </DxColumn>

                      <DxColumn caption="Tot.Wgt" alignment="center" :allow-editing="false">
                        <DxColumn data-field="unitWgt" caption="Material Spec3" alignment="right" :allow-editing="false" width="9%" data-type="number" format="#,##0.000" />
                      </DxColumn>

                      <DxColumn data-field="reqEmp" caption="Requester" alignment="left" :allow-editing="false" />

                      <DxSelection :allow-select-all="false" show-check-boxes-mode="always" mode="multiple" />
                    </DxDataGrid>
                  </v-col>
                </v-row>
              </v-col>
            </v-row>
          </template>
        </i-card-vertical>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import baseview from '@/components/base/baseview.vue'
import BaseDataGrid from '@/components/base/BaseDataGrid.vue'
import { getShipNoList1 } from '@/api/view/hip/common/common.js'
import { getCmChildCode } from '@/api/system/cmCodeManage'
import { epms9110List, epms9111List, epms9110Devide } from '@/api/view/hip/90/epms9110'
import { reportView } from '@/api/view/hip/common/common'
import notify from 'devextreme/ui/notify'

export default {
  name: 'epms9110',
  mixins: [baseview, BaseDataGrid],
  data() {
    return {
      makerCd: this.$store.state.user.makerCd,
      userId: this.$store.state.user.userId,
      menuTitle: this.$route.meta.title,
      epms9110Ref: 'epms9110Ref',
      epms9110Ref2: 'epms9110Ref2',
      dataList: [],
      dataList2: [],
      selectShipNo: null,
      shipNoList: [],
      selectLocation: null,
      locationList: [],
      reservNo: '',
      useBtnList: ['btnRetrieve'],
      useBtnList2: ['btnPrint', 'btnDevide']
    }
  },
  computed: {
    gridInstance() {
      return this.GetDataGrid(this.epms9110Ref)
    },
    grid2Instance() {
      return this.GetDataGrid(this.epms9110Ref2)
    }
  },
  methods: {
    async init() {
      this.gridInstance.option('defaultPaging', false)
      this.grid2Instance.option('defaultPaging', false)

      await this.getShipNoList()
      await this.getLocation()
      this.btnRetrieve()
    },
    async getShipNoList() {
      const param = {
        makerCd: this.makerCd
      }

      await getShipNoList1(param).then(async res => {
        // console.log('getShipNoList1Res', res)

        this.shipNoList = res.list
        this.shipNoList.unshift({
          shipNo: ''
        })
        this.selectShipNo = this.shipNoList[0]
      })
    },
    async getLocation() {
      await getCmChildCode({
        code: '',
        codegr: '',
        prtCode: '906_LOC',
        userFlag: 'Y'
      }).then(res => {
        if(this.makerCd === '90263') {
          this.locationList = res.list
        }
        
        this.locationList.unshift({
          code: '',
          codeName: ''
        })
        this.selectLocation = this.locationList[0]
      })
    },
    btnRetrieve() {
      this.gridInstance.option('focusedRowIndex', -1)
      this.gridInstance.clearSelection()
      this.grid2Instance.clearSelection()
      this.dataList = []
      this.dataList2 = []
      this.reservNo = ''

      const param = {
        shipNo: this.selectShipNo.shipNo,
        delyLoc: this.selectLocation.code,
        makerCd: this.makerCd
      }

      this.openLoading()
      epms9110List(param).then(res => {
        this.dataList = res.list

        if(this.dataList.length > 0) {
          this.gridInstance.option('focusedRowIndex', 0)
          this.reservNo = this.dataList[0].resNo
          this.getDetail()
        }
      }).finally(() => {
        this.endLoading()
      })
    },
    getDetail(resNo) {
      this.grid2Instance.clearSelection()
      this.dataList2 = []

      const param = {
        resNo: this.reservNo,
        makerCd: this.makerCd
      }

      this.openLoading()
      epms9111List(param).then(res => {
        let result = res.list
        let makeData = []
        // let id = 0

        result.forEach(row => {
          const isAlter = row.id % 2 === 0

          // id++
          let row1 = JSON.parse(JSON.stringify(row))
          // row1.id = id
          row1.gbn = 1
          row1.isAlter = isAlter
          makeData.push(row1)

          // id++
          let row2 = JSON.parse(JSON.stringify(row))
          // row2.id = id
          row2.gbn = 2
          row2.isAlter = isAlter
          makeData.push(row2)
        })

        this.dataList2 = makeData
      }).finally(() => {
        this.endLoading()
      })
    },
    btnPrint() {
      if(!this.reservNo) {
        return
      }
      
      let param = {
        as_res_no: this.reservNo,
        as_maker_cd: this.$store.state.user.makerCd,
        fileName: 'epms9110.jrxml'
      }

      // console.log('param', param)

      this.openLoading()
      reportView(param).finally(() => {
        this.endLoading()
      })
    },
    async btnDevide() {
      let delData = await this.grid2Instance.getSelectedRowsData()

      if(delData.length < 1) {
        this.vToastify(this.$t('Data is not selected.'), 'warn')
        return
      }
      
      this.openLoading()
      epms9110Devide(delData).then(res => {
        const msg = res.body
        if(msg === 'OK') {
          notify(this.$t('Reservation was divided.'), 'success', 3000)
          this.btnRetrieve()
        } else {
          this.vToastify(this.$t(msg), 'warn')
          return
        }
      }).finally(() => {
        this.endLoading()
      })
    },
    cellClick(e) {
      // console.log('cellClick Event', e)

      if(e.rowType === 'data') {
        if(e.rowIndex >= 0) {
          this.reservNo = e.data.resNo
          this.getDetail()
        }
      }
    },
    cellPrepared2(e) {
      if(e.rowType === 'header') {
        const caption = e.column.caption

        if(e.column.command === 'select') {
          e.cellElement.innerText = 'Sel'
        }
        
        if(caption && caption.indexOf('Material Spec') > -1) {
          if(caption === 'Material Spec') {
            e.cellElement.setAttribute('colspan', 4)
          } else {
            e.cellElement.style.display = 'none'
          }
        }
      } else if(e.rowType === 'data') {
        if(e.rowIndex >= 0) {
          if(e.data.isAlter) {
            e.cellElement.classList.add('custom-alter-row')
          } else {
            e.cellElement.classList.add('custom-row')
          }

          if(e.column.command === 'select') {
            if(e.data.gbn === 1) {
              e.cellElement.setAttribute('rowspan', 2)
            } else {
              e.cellElement.style.display = 'none'
            }
          }

          if(e.column.dataField === 'resSeq' || e.column.dataField === 'block') {
            if(e.data.gbn === 1) {
              e.cellElement.setAttribute('rowspan', 2)
            } else {
              e.cellElement.style.display = 'none'
            }
          }

          if(e.column.dataField === 'partNo') {
            if(e.data.gbn === 2) {
              e.cellElement.setAttribute('colspan', 4)
              e.cellElement.style.textAlign = 'left'
            }
          }

          if(e.column.dataField === 'resQty' || e.column.dataField === 'partUnitWgt' || e.column.dataField === 'unitWgt') {
            if(e.data.gbn === 2) {
              e.cellElement.style.display = 'none'
            }
          }
        }
      }
    }
  },
  mounted() {
    this.init()
  }
}
</script>

<style lang="scss" scoped>

</style>
